import { render, staticRenderFns } from "./TerminalHuaBan.vue?vue&type=template&id=68666203&"
import script from "./TerminalHuaBan.vue?vue&type=script&lang=js&"
export * from "./TerminalHuaBan.vue?vue&type=script&lang=js&"
import style0 from "./TerminalHuaBan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports